import React from "react";
import ToastContainer from "react-bootstrap/ToastContainer";
import Toast from "react-bootstrap/Toast";
import { NotificationProps } from "./types";

export const Notification: React.FunctionComponent<NotificationProps> = ({
  show,
  timer,
  handleClose,
  autohide = false,
  title,
  description,
  subtitle,
  position = "bottom-start",
  variant = "light",
}) => {
  return (
    <ToastContainer position={position}>
      <Toast
        onClose={() => handleClose()}
        show={show}
        delay={timer}
        autohide={autohide}
        bg={variant}
      >
        <Toast.Header>
          <img src="holder.js/20x20?text=%20" className="rounded me-2" alt="" />
          <strong className="mx-auto">{title}</strong>
          <small>{subtitle}</small>
        </Toast.Header>
        <Toast.Body
          className={
            (variant === "success" || variant === "danger") && "text-white"
          }
        >
          <div
            style={{
              textAlign: "center",
            }}
          >
            {description}
          </div>
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );
};
